import { mailRequest } from '../mailboxModel';

// Actor-scoped, in-flight deduplication. Never persist private mailbox images.
const requests = new Map();
const failures = new Map();
export function acquireSenderImage(downloadUrl) {
  // Only send credentials to the documented mailbox route, never provider URLs.
  if (typeof downloadUrl !== 'string' || !/^\/mailbox\/messages\/[^/?#]+\/sender-image$/.test(downloadUrl)) return null;
  const token = localStorage.getItem('accessToken');
  if (!token) return null;
  const key = JSON.stringify([token, downloadUrl]);
  if (failures.has(key)) return null;
  let entry = requests.get(key);
  if (!entry) {
    entry = { users: 0, settled: false };
    entry.promise = mailRequest(downloadUrl.slice('/mailbox'.length), { responseType: 'blob' }).then(blob => {
      if (!blob?.size || blob.type?.split(';')[0] !== 'image/webp') throw new Error('Invalid sender image');
      return blob;
    }).catch(() => {
      failures.set(key, true);
      if (failures.size > 128) failures.delete(failures.keys().next().value);
      return null;
    }).finally(() => {
      entry.settled = true;
      if (!entry.users) requests.delete(key);
    });
    requests.set(key, entry);
  }
  entry.users += 1;
  let released = false;
  return { promise: entry.promise, release: () => {
    if (released) return;
    released = true;
    entry.users -= 1;
    if (!entry.users && entry.settled) requests.delete(key);
  } };
}
